import ApiUtils from "../ApiUtils";

export default class ApiTopicExamService {

    async copyExamTopic(data){
        return await ApiUtils.callApi('topic/exam/copy', 'post', data);
    }
}

